import { Analytics } from '@vercel/analytics/react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import VotingScreen from './components/VotingScreen/VotingScreen';
import DashboardPage from './components/Dashboard/DashboardPage';

const theme = createTheme({
  typography: {
    fontFamily:
      '"SF Pro Display", "SF Pro Text", -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Segoe UI", Arial, sans-serif',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const isDashboardRoute = window.location.pathname.startsWith('/dashboard');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isDashboardRoute ? <DashboardPage /> : <VotingScreen />}
      <Analytics />
    </ThemeProvider>
  );
}

export default App; 